import React, { useState, useEffect } from 'react';
import './App.css';
import Body from './Body.js';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Carousel from "./Carousel";
import { CATEGORIES } from './Categories';
import Slider from 'react-slick';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';

function App() {
  const [open, setOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState(null);

  const toggleDrawer = (value) => () => {
    setOpen(value);
  };

  const HEADER_OFFSET = 100;

  const handleNavClick = (nation) => () => {
    const id = nation.replace(/\s/g, '') + 'background';

    setOpen(false);

    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        const elementTop = el.getBoundingClientRect().top + window.scrollY;
        const scrollTo = elementTop - HEADER_OFFSET;

        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });
      }
    }, 200);
  };

  useEffect(() => {
    const sectionIds = CATEGORIES.map(
      (nation) => nation.replace(/\s/g, '') + 'background'
    );

    const onScroll = () => {
      const scrollPos = window.scrollY;
      const headerOffset = HEADER_OFFSET;

      let activeId = null;

      sectionIds.forEach((sectionId) => {
        const el = document.getElementById(sectionId);
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;

        if (scrollPos + headerOffset >= elementTop - 40) {
          activeId = sectionId.replace('background', '');
        }
      });

      if (activeId && activeId !== currentSection) {
        setCurrentSection(activeId);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [HEADER_OFFSET, currentSection]);

  const paymentImages = [
    "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/stickers%2FIMG_9053.jpeg?alt=media&token=cd4412cc-a8f6-4f66-ad11-1a8b31864eaa",
    "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/stickers%2FIMG_9051.png?alt=media&token=0adbdf78-ec55-457e-bc6a-1471c27511b0",
    "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/stickers%2FIMG_9052.jpeg?alt=media&token=665bf330-e2e0-4c4e-a955-7e6019e68c37",
  ];

  const paymentSliderSettings = {
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: true,
  };

  return (
    <div className="App" style={{ overflowX: 'hidden' }}>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#ba83e9',
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <span
            style={{ fontWeight: 600, cursor: 'pointer' }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            Jwoomycorn
          </span>

          <IconButton
            className="hamburger"
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            backgroundColor: '#ba83e9',
            color: 'white',
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <div
          style={{
            padding: '1.5rem 1rem 1rem',
            textAlign: 'center',
            borderBottom: '1px solid rgba(255,255,255,0.25)',
          }}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/stickers%2FIMG_4909.png?alt=media&token=ba647eb2-270a-4633-876c-619862b4ffc8"
            alt="Jwoomycorn logo"
            style={{
              width: '80px',
              display: 'block',
              margin: '0 auto 0.5rem',
            }}
          />

          <div
            style={{
              fontWeight: 700,
              fontSize: '1.1rem',
              letterSpacing: '0.05em',
              paddingBottom: '0.75rem',
            }}
          >
            Categories
          </div>
        </div>

        <List sx={{ width: 240 }}>
          {CATEGORIES.map((nation) => (
            <ListItem key={nation} disablePadding>
              <ListItemButton
                onClick={handleNavClick(nation)}
                disableRipple
                selected={currentSection === nation.replace(/\s/g, '')}
                sx={{
                  borderRadius: '999px',
                  mx: 1,
                  my: 0.5,
                  // '&:hover': {
                  //   backgroundColor: 'rgba(255,255,255, 0.40)',
                  // },
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(255,255,255,0.25)',
                  }
                }}
              >
                <ListItemText
                  primary={nation}
                  primaryTypographyProps={{
                    fontSize: '1rem',
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>

      <header className="App-header" style={{ paddingTop: '64px' }}>
        <div
          style={{
            backgroundColor: '#ba83e9',
          }}
        >
          <img
            style={{
              width: '50%',
            }}
            src="https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/stickers%2FIMG_4909.png?alt=media&token=ba647eb2-270a-4633-876c-619862b4ffc8"
            alt="header"
          />
        </div>

        <Carousel />

        <div
          style={{
            background: '#ba83e9',
            padding: '2rem 0',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            variant="contained"
            onClick={() => setPaymentOpen(true)}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1.5,
              color:'#ba83e9',
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#a067d4', color:'#ffffff' },
            }}
          >
            Payment Methods
          </Button>
          <Dialog
            fullScreen
            open={paymentOpen}
            onClose={() => setPaymentOpen(false)}
            PaperProps={{
              sx: {
                backgroundColor: 'rgba(0,0,0,0.9)',
                color: 'white',
              },
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '0.5rem 1rem',
              }}
            >
              <IconButton
                onClick={() => setPaymentOpen(false)}
                sx={{
                  color: 'white',
                  width: 84,
                  height: 84,
                }}
                aria-label="Close payment methods"
              >
                <CloseIcon sx={{ fontSize: 64 }} />
              </IconButton>
            </div>

            <DialogContent
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 0,
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setPaymentOpen(false);
                }
              }}
            >
              <div
                className="payment-slider"
                onClick={(e) => e.stopPropagation()}
              >
                <Slider {...paymentSliderSettings}>
                  {paymentImages.map((url, i) => (
                    <div key={i}>
                      <img src={url} alt={`payment-${i + 1}`} />
                    </div>
                  ))}
                </Slider>
              </div>
            </DialogContent>

          </Dialog>

        </div>
        <Body />
      </header>
    </div>
  );
}

export default App;
